<template>
  <div class="contact">
    <h2>Contact Us</h2>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="name">Name:</label>
        <input type="text" id="name" v-model="name" required maxlength="128">
      </div>
      <div class="form-group">
        <label for="email">Email:</label>
        <input type="email" id="email" v-model="email" required maxlength="128">
      </div>
      <div class="form-group">
        <label for="message">Message:</label>
        <textarea id="message" v-model="message" required maxlength="1024"></textarea>
      </div>
      <button type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { saveMessage } from '@/services/contactService';

export default {
  name: 'ContactPage',
  setup() {
    const name = ref('');
    const email = ref('');
    const message = ref('');

    const submitForm = async () => {
      try {
        await saveMessage({ name: name.value, email: email.value, message: message.value });
        alert('Message sent successfully!');
        name.value = '';
        email.value = '';
        message.value = '';
      } catch (error) {
        console.error('Error sending message:', error);
        alert('Failed to send message. Please try again.');
      }
    };

    return {
      name,
      email,
      message,
      submitForm
    };
  }
}
</script>

<style scoped>
.contact {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  color: black;
  font-family: 'Courier New', Courier, monospace;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input, textarea {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

button {
  background-color: red;
  color: white;
  padding: 10px 15px;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: darkred;
}
</style>
